export const wizardStepsGG = Object.freeze({
  DIMENSIONS: 'Maße',
  SPACING: 'Teilung',
  ELEMENT_COUNT: 'Gliederzahl',
  WATER_CHAMBER_WIDTH: 'Wasserkammerbreite',
  COLUMN_COUNT: 'Säulenanzahl',
  COLUMN_SHAPE: 'Säulenform',
  COLUMN_TYPE: 'Säulenart',
  DECORATION: 'Verzierung',
  CONNECTION_TYPE: 'Anschlussart',
  MANUFACTURER: 'Hersteller',
});

export const imagesGG = Object.freeze({
  SPACING: new URL('@/assets/img/radiators/GG/spacing.svg', import.meta.url)
    .href,
  WATER_CHAMBER_WIDTH: new URL(
    '@/assets/img/radiators/GG/waterChamberWidth.svg',
    import.meta.url
  ).href,
  DIMENSIONS: new URL(
    '@/assets/img/radiators/GG/dimensions.svg',
    import.meta.url
  ).href,
  COLUMN_COUNT: new URL(
    '@/assets/img/radiators/GG/columnCount.png',
    import.meta.url
  ).href,
  ELEMENT_COUNT: new URL(
    '@/assets/img/radiators/GG/elementCount.svg',
    import.meta.url
  ).href,
});

export const connectionTypesGG = Object.freeze([
  {
    name: 'E',
    subtitle: 'Gleichseitiger Anschluss, mit oberem Vorlauf',
    value: 'E1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'E',
    subtitle: 'Untere Anbindung mit Trennscheibe im Vorlauf',
    value: 'E2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E2.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'E',
    subtitle: 'Obere Vorlaufeinführung in Verbindung mit unterer Anbindung',
    value: 'E3',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E3.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'E',
    subtitle: 'Obere Vorlaufeinführung in Verbindung mit unterer Anbindung',
    value: 'E4',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E4.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'E',
    subtitle:
      'Untere Vorlaufeinführung Achtung! Keine HKV-Montage, siehe Handbuch',
    value: 'E5',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_E5.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'W',
    subtitle: 'Vorlauf oben, Rücklauf unten',
    value: 'W1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_W1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'W',
    subtitle: 'Kurzschlussstrecke (Einrohrsystem)',
    value: 'W2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_W2.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'W',
    subtitle: 'Reihenschaltung von mehreren Heizkörpern',
    value: 'W3',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_W3.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'W',
    subtitle:
      'Untere Vorlaufeinführung Achtung! Keine HKV-Montage, siehe Handbuch',
    value: 'W4',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_W4.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'R',
    subtitle: 'Beide Anschlüsse unten, links und rechts',
    value: 'R1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_R1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'R',
    subtitle: 'Kurzschlussstrecke (Einrohrsystem)',
    value: 'R2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_R2.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'R',
    subtitle: 'Reihenschaltung von mehreren Heizkörpern',
    value: 'R3',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_R3.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'S',
    subtitle: 'Mit unterer Trennscheibe am Vorlauf oder mittig',
    value: 'S1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_S1.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'S',
    subtitle:
      'Obere Einführung von Vor- und Rücklauf, obere Trennscheibe am Rücklauf',
    value: 'S2',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_S2.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'S',
    subtitle: 'Reihenschaltung mit Trennscheibe vorlaufseitig',
    value: 'S3',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_S3.svg',
      import.meta.url
    ).href,
  },
  {
    name: 'M',
    subtitle: 'Mittenanschluss mit Ventileinsatz am Vorlaufanschluss',
    value: 'M1',
    image: new URL(
      '@/assets/img/radiators/common/connectionTypes/AA_M1.svg',
      import.meta.url
    ).href,
  },
]);

export const columnShapesGG = Object.freeze([
  {
    name: '1',
    subtitle: 'Symetrische einfache Form',
    value: 1,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_1.svg',
      import.meta.url
    ).href,
  },
  {
    name: '2',
    subtitle: 'Einfache Form, Rand glatt gekantet',
    value: 2,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_2.svg',
      import.meta.url
    ).href,
  },
  {
    name: '3',
    subtitle: 'Unsymmetrisch vorne glatt',
    value: 3,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_3.svg',
      import.meta.url
    ).href,
  },
  {
    name: '4',
    subtitle: 'Asymmetrisch hinten breiter',
    value: 4,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_4.svg',
      import.meta.url
    ).href,
  },
  {
    name: '5',
    subtitle: 'Randumkantung',
    value: 5,
    image: new URL(
      '@/assets/img/radiators/GG/columnShape/SF_5.svg',
      import.meta.url
    ).href,
  },
]);

export const decorationsGG = Object.freeze([
  {
    name: '0',
    subtitle: 'ohne',
    value: 0,
    image: new URL(
      '@/assets/img/radiators/GG/decoration/V_0.png',
      import.meta.url
    ).href,
  },
  {
    name: '1',
    subtitle: 'teilverziert',
    value: 1,
    image: new URL(
      '@/assets/img/radiators/GG/decoration/V_1.png',
      import.meta.url
    ).href,
  },
  {
    name: '2',
    subtitle: '	vollverziert',
    value: 2,
    image: new URL(
      '@/assets/img/radiators/GG/decoration/V_2.png',
      import.meta.url
    ).href,
  },
]);

export const columnTypesGG = Object.freeze([
  {
    name: '1',
    subtitle: 'alle Säulen mit gleicher Form',
    value: 1,
    image: new URL('@/assets/img/radiators/GG/columnType/SA_1.svg', import.meta.url).href,
  },
  {
    name: '2',
    subtitle: 'unterschiedliche Säulenformen',
    value: 2,
    image: new URL('@/assets/img/radiators/GG/columnType/SA_2.svg', import.meta.url).href,
  },
]);
